<template>
<!--    <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--        <path d="M28.8669 21.001V14.9723L17.8667 6.59909V3.98665H24.5962V1.30722H6.60764V3.98665H13.2078V8.60866L24.5962 16.6469V21.001M6.60764 6.59909L1.49578 14.9723C1.36637 16.9819 2.20756 21.001 6.60764 21.001C11.0077 21.001 11.9352 16.9819 11.8489 14.9723L6.60764 6.59909Z" stroke="currentColor"/>-->
<!--    </svg>-->
    <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M26.3543 23.3537V17.7791L16.0464 10.0366V7.62092H18M22.3524 23.3537V19.3276L11.6806 11.8948V7.62092H5.49587V5.14331H13.9241H17.6916M5.49587 10.0366L0.705704 17.7791C0.584434 19.6373 1.37269 23.3537 5.49587 23.3537C9.61905 23.3537 10.4882 19.6373 10.4073 17.7791L5.49587 10.0366Z" stroke="currentColor"/>
        <circle cx="23.0441" cy="5.9711" r="5.29422" stroke="currentColor"/>
        <path d="M26.0158 6.11967C26.0158 6.33396 25.8421 6.50768 25.6278 6.50768H23.3725V8.74841C23.3725 8.97074 23.1923 9.15097 22.9699 9.15097V9.15097C22.7476 9.15097 22.5674 8.97074 22.5674 8.74841V6.50768H20.3121C20.0978 6.50768 19.9241 6.33396 19.9241 6.11967V6.11967C19.9241 5.90538 20.0978 5.73167 20.3121 5.73167H22.5674V3.49093C22.5674 3.26861 22.7476 3.08838 22.9699 3.08838V3.08838C23.1923 3.08838 23.3725 3.26861 23.3725 3.49093V5.73167H25.6278C25.8421 5.73167 26.0158 5.90538 26.0158 6.11967V6.11967Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGGutterPlus"
    }
</script>

<style scoped>

</style>
